<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12">
      <hr />
    </div>
    <div v-if="!passwordFlag">
      <div id="profile-body" class="col-sm-12 col-md-12 col-xs-12">
        <div id="profile-icon" class="col-sm-6">
          <div class="col-sm-12 col-xs-5 xs-pd-lt-0">
            <div class="profile-pic-edit profile-pic-title-edit" v-if="loggedInInitialsFlag">
              {{ getInitials(loggedInUser.first_name, loggedInUser.last_name) }}
            </div>
            <img
              class="profile-pic-edit"
              v-if="!loggedInInitialsFlag"
              :src="imageData"
              alt="profile-icon"
            />
          </div>
          <div class="col-sm-12 col-xs-7 p-0">
            <div class="col-xs-12 p-0">
              <button class="btn chng-photo emergo-white-button">
                Change Photo
                <input
                  type="file"
                  ref="fileImage"
                  @change="previewImage"
                  accept="image/*"
                  class="file-upload-hide"
                />
              </button>
            </div>
            <div class="col-xs-12 p-0">
              <button
                class="font-properties cursor-pointer fs-16 ln-ht19 remove_photo"
                :disabled="loggedInInitialsFlag"
                @click="removePhotoUseInitials"
              >
                Remove Photo
              </button>
            </div>
          </div>
        </div>
        <div
          id="profile-details"
          class="col-sm-6 col-md-6 col-xs-12"
          v-if="Object.keys(loggedInUser).length"
        >
          <div class="row">
            <div class="col-sm-12 col-xs-12 form-group">
              First Name <span class="required">*</span>
            </div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                maxlength="35"
                @keyup="checkUpdatedFields"
                v-model="loggedInUser.first_name"
              />
            </div>
            <div class="col-sm-12 col-xs-12 form-group">
              Last Name <span class="required">*</span>
            </div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                maxlength="35"
                @keyup="checkUpdatedFields"
                v-model="loggedInUser.last_name"
              />
            </div>
            <div class="col-sm-12 col-xs-12 form-group">Title</div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                maxlength="50"
                @keyup="checkUpdatedFields"
                v-model="loggedInUser.title"
              />
            </div>
            <div class="col-sm-12 col-xs-12 form-group">Legal Company Name</div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                disabled="disabled"
                v-model="loggedInUser.company"
              />
            </div>
            <div class="col-sm-12 col-xs-12 form-group">Email</div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                disabled="disabled"
                v-model="loggedInUser.email"
              />
            </div>
            <div class="col-sm-12 col-xs-12 form-group">Account ID</div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                type="text"
                class="form-control"
                disabled="disabled"
                v-model="loggedInUser.account_id"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12 sec-pad">Security</div>
          <div class="col-sm-12 col-xs-12">
            <hr />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="row">
              <div class="col-sm-4 col-md-4 col-xs-8">
                <button
                  type="button"
                  class="btn btn-block emergo-blue-button"
                  @click="redirectChangePassword"
                >
                  Change Password
                </button>
              </div>
              <div
                class="col-sm-4 col-md-4 col-xs-8 pl-0 d-flex"
                v-if="
                  loggedInUser.role_id === 1 &&
                  loggedInUser.account_type_id === 3 &&
                  loggedInUser.id === userData.id
                "
              >
                <button
                  type="button"
                  class="btn btn-block emergo-white-button"
                  @click="deactivateModal"
                >
                  Deactivate Account
                </button>
                <div class="ml-6 pt-5">
                  <el-popover
                    class="cursor-pointer custom-popover"
                    placement="bottom-end"
                    trigger="click"
                    @show="infoActiveAcct = true"
                    @hide="infoActiveAcct = false"
                    width="360"
                  >
                    <div class="limit_popover_txt">
                      By deactivating your account, you and all team members on this account will
                      lose access to all data available within RAMS. You can be added as a team
                      member on another RAMS account.
                    </div>
                    <!-- <template #reference> -->
                    <img
                      class="info-img"
                      src="/static/images/icons/info_icon.svg"
                      v-if="!infoActiveAcct"
                      alt="info-icon"
                      slot="reference"
                    />
                    <img
                      class="info-img"
                      src="/static/images/icons/info_icon_active.svg"
                      v-if="infoActiveAcct"
                      alt="infoactive-icon"
                      slot="reference"
                    />
                    <!-- </template> -->
                  </el-popover>
                </div>
                <!-- <span class="tooltiptext">By deactivating your account, you and all team members on this account will lose access to all data available within RAMS. You can be added as a team member on another RAMS account or sign up for a new account at any time.</span> -->
              </div>
              <div
                class="col-sm-12 col-md-12 col-xs-12 support-access"
                v-if="loggedInUser.role_id === 1 && loggedInUser.account_type_id === 3"
              >
                <div>
                  <span class="checkbox inline-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        v-model="loggedInUser.allow_support_access"
                        @change="checkUpdatedFields"
                      />
                      <span class="cr">
                      </span>
                    </label>
                  </span>
                  <span
                    >Allow temporary authorized technical support access
                    <el-popover
                      class="cursor-pointer custom-popover"
                      placement="bottom-end"
                      trigger="click"
                      @show="infoActive = true"
                      @hide="infoActive = false"
                      width="360"
                    >
                      <div class="limit_popover_txt">
                        By checking this box, you are enabling authorized Technical Support
                        personnel to gain access to your RAMS account and data. Temporary access
                        expires after 72 hours
                      </div>
                      <!-- <template #reference> -->
                      <img
                        class="info-img"
                        src="/static/images/icons/info_icon.svg"
                        v-if="!infoActive"
                        alt="info-icon"
                        slot="reference"
                      />
                      <img
                        class="info-img"
                        src="/static/images/icons/info_icon_active.svg"
                        v-if="infoActive"
                        alt="infoactive-icon"
                        slot="reference"
                      />
                      <!-- </template> -->
                    </el-popover>
                  </span>
                </div>
              </div>
            </div>
            <div class="modal deactive-modal" role="dialog" data-backdrop="static">
              <div class="modal-dialog" role="document">
                <div class="modal-content deactivate-acct">
                  <div class="modal-header upgradeModal-bgcolor">
                    <button
                      type="button"
                      class="close"
                      @click="closePopup"
                      data-target="#UpgradeModal"
                    >
                      &times;
                    </button>
                    <div class="modal-title">
                      <img
                        src="/static/images/icons/expiring_yellow.svg"
                        alt="expiring-soon"
                        class="expiry-img"
                      />
                      <span>This Account will be Deactivated</span>
                    </div>
                  </div>
                  <div class="modal-body deactivate-body">
                    All associated access will be removed for all team members on this account. You
                    will be immediately logged out. Do you want to proceed with account
                    deactivation?
                  </div>
                  <div class="modal-footer cancelModal-bgcolor">
                    <div class="row">
                      <div class="col-lg-offset-6 col-md-offset-6">
                        <button
                          class="btn proceed-btn emergo-white-button"
                          @click="deactivateAccount"
                        >
                          Yes, proceed
                        </button>
                        <button class="btn please-cancel" @click="closePopup()">Dismiss</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer col-xs-12 col-sm-12">
        <div class="col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0">
          <button
            type="button"
            class="btn btn-block emergo-white-button"
            @click="$emit('closepopup', 'closeBasePopup')"
          >
            Cancel
          </button>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
          <button
            type="button"
            class="btn btn-block emergo-green-button"
            @click="updateProfile"
            :disabled="disableButtonForProfile || loaderStatus"
          >
            Save Changes
          </button>
        </div>
      </div>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
    <div v-else id="change-password">
      <div id="body" class="col-lg-6 col-sm-12 col-md-12 col-xs-12 changepassword_wrapper">
        <div class="col-lg-12 col-md-6 col-sm-7 pass-info">
          <p class="pass-desc pl-0">Provide password details below:</p>
          <el-popover
            popper-append-to-body="false"
            placement="bottom-end"
            class="info-icon-class"
            trigger="click"
            popper-class="popup-background profile-popup tootip-custom-small-width-class"
            @show="passwordInfoActive = true"
            @hide="passwordInfoActive = false"
          >
            <div class="content">
              <ul class="word-break">
                <li>
                  <span
                    >Please fill the mandatory details (if any) for all steps and they will be
                    available with “</span
                  >
                  <span class="mandatory-sign">*</span><span>” symbol.</span>
                </li>
                <li>Have at least one capital letter</li>
                <li>Have at least one number</li>
                <li>Have at least one special character !@#$.,+=( )_%^&*</li>
                <li>Be at least 10 characters</li>
              </ul>
            </div>
            <img
              class="info-img"
              src="/static/images/icons/info_icon.svg"
              v-if="!passwordInfoActive"
              alt="info-icon"
              slot="reference"
            />
            <img
              class="info-img"
              src="/static/images/icons/info_icon_active.svg"
              v-if="passwordInfoActive"
              alt="infoactive-icon"
              slot="reference"
            />
          </el-popover>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 pt-10">
            <div class="col-xs-12 col-sm-12 form-group">Current Password</div>
            <div
              class="col-xs-12 col-sm-6 col-md-6 col-lg-12 password-flex"
              :class="!currentPasswordFlag ? 'pb-8' : 'pb-22'"
            >
              <input
                ref="inputCurrentTag"
                :class="!currentPasswordFlag ? 'invalid-border' : ''"
                type="password"
                class="form-control eye"
                placeholder="Current password"
                v-model="password.current_password"
                @blur="validateCurrentPassword"
              />
              <img
                v-if="showCurrentPassword"
                src="/static/images/icons/eye.svg"
                class="eye-icon"
                @click="togglePassword($refs.inputCurrentTag, 'showCurrentPassword')"
                alt="eye-icon"
              />
              <img
                v-if="!showCurrentPassword"
                src="/static/images/icons/eye_slash.svg"
                class="eye-slash-icon"
                @click="togglePassword($refs.inputCurrentTag, 'showCurrentPassword')"
                alt="eye-icon"
              />
            </div>
            <div class="col-xs-8 custom-error-class" v-if="!currentPasswordFlag">
              Current password is incorrect
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 pt-10">
            <div class="col-xs-12 col-sm-12 form-group">New Password</div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-12 password-flex pb-20">
              <input
                ref="inputNewTag"
                type="password"
                class="form-control eye"
                placeholder="New password"
                v-model.trim="password.new_password"
                @input="validate"
              />
              <img
                v-if="showNewPassword"
                src="/static/images/icons/eye.svg"
                class="eye-icon"
                @click="togglePassword($refs.inputNewTag, 'showNewPassword')"
                alt="eye-icon"
              />
              <img
                v-if="!showNewPassword"
                src="/static/images/icons/eye_slash.svg"
                class="eye-slash-icon"
                @click="togglePassword($refs.inputNewTag, 'showNewPassword')"
                alt="eye-icon"
              />
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 mt-10">
            <div class="col-xs-12 col-sm-12 form-group">Confirm Password</div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-12 password-flex pb-5">
              <input
                ref="inputConfirmTag"
                type="password"
                class="form-control eye"
                :class="
                  password.confirm_password.length &&
                  password.new_password != password.confirm_password
                    ? 'invalid-border'
                    : ''
                "
                placeholder="Confirm password"
                v-model.trim="password.confirm_password"
              />
              <img
                v-if="showConfirmPassword"
                src="/static/images/icons/eye.svg"
                class="eye-icon"
                @click="togglePassword($refs.inputConfirmTag, 'showConfirmPassword')"
                alt="eye-icon"
              />
              <img
                v-if="!showConfirmPassword"
                src="/static/images/icons/eye_slash.svg"
                class="eye-slash-icon"
                @click="togglePassword($refs.inputConfirmTag, 'showConfirmPassword')"
                alt="eye-icon"
              />
            </div>
            <div
              class="col-xs-8 custom-error-class"
              v-if="password.confirm_password && password.new_password != password.confirm_password"
            >
              Password does not match.
            </div>
          </div>
        </div>
      </div>
      <div class="footer col-xs-12 col-sm-12">
        <div class="col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0">
          <button
            type="button"
            class="btn btn-block emergo-white-button"
            @click="unsetPasswordFlag"
          >
            Cancel
          </button>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
          <button
            type="button"
            class="btn btn-block emergo-green-button"
            @click="updatePassword"
            :disabled="!currentPasswordFlag || disableButtonForChangePassword || loaderStatus"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <div id="confirmPopup" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor">
            <button type="button" class="close" data-toggle="modal" data-target="#confirmPopup">
              &times;
            </button>
          </div>
          <div class="modal-body confirm-body">
            Would you like to save your changes before leaving the page?
          </div>
          <div class="modal-footer confirmpopup-bgcolor">
            <div class="col-md-6 col-sm-6 col-xs-12 profile-footer-save">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="confirmChanges"
              >
                Save Changes
              </button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                @click="cancelConfirmPopUp"
              >
                Discard Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { Popover } from 'element-ui';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';
import { updateProfileData, getProfileData, getUserData } from '../../apis/profile';
import { changePassword } from '../../apis/passwords';
import {
  isContainsUpperCase,
  isContainsLowerCase,
  isContainsDigit,
  isContainsSpecialChar,
  checkConditions
} from '../Register/validator';
import { deactivateAccountSelf, getCurrentUserPassword } from '../../apis/activityTracker';
// import BasePopover from '../Common/BasePopover.vue';

export default {
  components: {
    Loader,
    // BasePopover,
    'el-popover': Popover
  },
  props: ['closeSubPage'],
  data() {
    return {
      showCurrentPassword: true,
      showNewPassword: true,
      showConfirmPassword: true,
      currentPasswordFlag: true,
      passwordInfoActive: false,
      infoActive: false,
      infoActiveAcct: false,
      errors: [],
      loaderStatus: false,
      loggedInInitialsFlag: false,
      imageData: '',
      imageExists: false,
      loggedInUser: {},
      passwordFlag: false,
      password: {
        current_password: '',
        new_password: '',
        confirm_password: ''
      },
      disableButtonForProfile: true,
      changePasswordNavHold: false,
      closeBasePopup: 'default',
      changePasswordError: '',
      isPasswordLength: false,
      PasswordError: false,
      verification: [
        { message: 'Have at least one capital letter', valid: false },
        { message: 'Have at least one lowercase letter', valid: false },
        { message: 'Have at least one number', valid: false },
        { message: 'Have at least one special character', valid: false }
      ]
    };
  },
  async created() {
    if (!this.passwordFlag) this.loadProfile();
    this.userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
  },
  watch: {
    closeSubPage(val) {
      if (val === 'close') {
        this.unsetPasswordFlag();
      }
    }
  },
  computed: {
    disableButtonForChangePassword() {
      if (this.PasswordError) {
        return true;
      }
      if (this.passwordFlag) {
        if (
          this.password.current_password !== '' &&
          this.password.new_password !== '' &&
          this.password.confirm_password !== '' &&
          this.password.new_password.length >= 10 &&
          this.password.confirm_password.length >= 10 &&
          this.password.new_password === this.password.confirm_password
        ) {
          const counter = checkConditions(this.password.new_password);
          if (counter >= 3) {
            return false;
          }
        }
      }
      return true;
    }
  },
  methods: {
    togglePassword(tagName, passwordString) {
      if (passwordString === 'showCurrentPassword') {
        this.showCurrentPassword = !this.showCurrentPassword;
        if (!this.showCurrentPassword) {
          tagName.type = 'text';
        } else {
          tagName.type = 'password';
        }
      } else if (passwordString === 'showNewPassword') {
        this.showNewPassword = !this.showNewPassword;
        if (!this.showNewPassword) {
          tagName.type = 'text';
        } else {
          tagName.type = 'password';
        }
      } else {
        this.showConfirmPassword = !this.showConfirmPassword;
        if (!this.showConfirmPassword) {
          tagName.type = 'text';
        } else {
          tagName.type = 'password';
        }
      }
    },
    async validateCurrentPassword() {
      if (this.password.current_password.length)
        this.currentPasswordFlag = await getCurrentUserPassword(this.password.current_password);
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    async confirmChanges() {
      $('#confirmPopup').modal('toggle');
      await this.updateProfile();
    },
    cancelConfirmPopUp() {
      this.disableButtonForProfile = true;
      $('#confirmPopup').modal('toggle');
      if (this.changePasswordNavHold) {
        this.setPasswordFlag();
      } else {
        this.$emit('closedConfirmPopup', this.closeBasePopup);
        this.closeBasePopup = 'default';
      }
    },
    toggleConfirmPopUp(closeBasePopup = 'default') {
      this.closeBasePopup = closeBasePopup;
      $('#confirmPopup').modal('toggle');
    },
    checkUpdatedFields() {
      const response = JSON.parse(localStorage.getItem('userData'));
      if (this.loggedInUser.first_name === '' || this.loggedInUser.last_name === '') {
        this.disableButtonForProfile = true;
        return;
      }
      if (
        response.first_name !== this.loggedInUser.first_name ||
        response.last_name !== this.loggedInUser.last_name ||
        response.title !== this.loggedInUser.title ||
        response.allow_support_access !== this.loggedInUser.allow_support_access
      ) {
        this.disableButtonForProfile = false;
        return;
      }
      if (response.profile_pic === null || response.profile_pic === '') {
        if (this.imageData !== null && this.imageData !== '') {
          this.disableButtonForProfile = false;
          return;
        }
      } else if (this.imageData === null || this.imageData === '') {
        this.disableButtonForProfile = false;
        return;
      }
      if (response.profile_pic !== null || response.profile_pic !== '') {
        if (this.imageData !== null && this.imageData !== '') {
          this.disableButtonForProfile = false;
          return;
        }
      }
      this.disableButtonForProfile = true;
    },
    validate() {
      this.counter = 0;
      if (this.password.new_password) {
        this.verification[0].valid = isContainsUpperCase(this.password.new_password);
        this.verification[1].valid = isContainsLowerCase(this.password.new_password);
        this.verification[2].valid = isContainsDigit(this.password.new_password);
        this.verification[3].valid = isContainsSpecialChar(this.password.new_password);
      }
      this.counter = checkConditions(this.password.new_password);
      this.isPasswordLength = false;
      if (this.password.new_password.length >= 10) this.isPasswordLength = true;

      this.passwordError = false;
      if (this.isPasswordLength && this.counter >= 3) {
        this.passwordError = true;
      }
    },
    redirectChangePassword() {
      if (this.disableButtonForProfile) {
        this.setPasswordFlag();
      } else {
        this.changePasswordNavHold = true;
        this.toggleConfirmPopUp();
      }
    },
    async deactivateAccount() {
      this.loaderStatus = true;
      const respData = await deactivateAccountSelf(JSON.parse(localStorage.getItem('accountId')));
      this.loaderStatus = false;
      if (respData.status_code === 200) {
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Account deactivated successfully!',
          group: 'custom-notification'
        });
        this.$emit('logoutUser');
      } else {
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Could not deactivate user!',
          group: 'custom-notification'
        });
      }
      $('#deactiveModal').modal('hide');
    },
    deactivateModal() {
      $('.deactive-modal').modal('show');
    },
    closePopup() {
      $('.deactive-modal').modal('hide');
    },
    async updatePassword() {
      this.loaderStatus = true;
      const data = {
        current_password: this.password.current_password,
        new_password: this.password.new_password
      };
      const response = await changePassword(data);
      if (!response) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Updating password failed!',
          group: 'custom-notification'
        });
      } else if (response && !response.status) {
        this.changePasswordError = response.message;
      } else {
        this.changePasswordError = '';
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Password updated successfully!',
          group: 'custom-notification'
        });
        this.passwordFlag = false;
        this.unsetPasswordFlag();
      }
      this.loaderStatus = false;
    },
    setPasswordFlag() {
      this.changePasswordNavHold = false;
      this.passwordFlag = true;
      this.$emit('emitBreadCrumb', 'Change Password');
    },
    unsetPasswordFlag() {
      this.password = { current_password: '', new_password: '', confirm_password: '' };
      this.passwordFlag = false;
      this.changePasswordError = '';
      this.$emit('emitBreadCrumb', false);
      this.loadProfile();
    },
    removePhotoUseInitials() {
      this.loggedInInitialsFlag = true;
      this.imageData = '';
      this.checkUpdatedFields();
    },
    async updateProfile() {
      this.loaderStatus = true;
      const data = {
        first_name: this.loggedInUser.first_name,
        last_name: this.loggedInUser.last_name,
        company: this.loggedInUser.company,
        email: this.loggedInUser.email
      };
      if (this.loggedInUser.allow_support_access !== null)
        data.allow_support_access = this.loggedInUser.allow_support_access;
      if (this.loggedInUser.title) data.title = this.loggedInUser.title;
      if (this.imageData) data.profile_pic = this.imageData;
      const response = await updateProfileData(data);
      if (response) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Profile updated successfully!',
          group: 'custom-notification'
        });
        await this.getProfileData();
        this.disableButtonForProfile = true;
        this.loaderStatus = false;
      }
    },
    async getProfileData() {
      this.loaderStatus = true;
      const userDataStorage = await getProfileData();
      if (userDataStorage) {
        localStorage.setItem('profileData', JSON.stringify(userDataStorage));
        EventBus.$emit('updateProfile', true);
      }
      const userData = JSON.parse(localStorage.getItem('userData'));
      if (userData && userData.id === userDataStorage.id)
        localStorage.setItem('userData', JSON.stringify(userDataStorage));
    },
    previewImage(event) {
      const input = event.target;
      const fileLoader = this.$refs.fileImage;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
          this.loggedInInitialsFlag = false;
          fileLoader.value = null;
          this.checkUpdatedFields();
        };
        reader.readAsDataURL(input.files[0]);
      }
    },

    async loadProfile() {
      this.loaderStatus = true;
      this.loggedInUser = {};
      const response = localStorage.getItem('profileData')
        ? JSON.parse(localStorage.getItem('profileData'))
        : await getProfileData();
      this.loaderStatus = false;
      this.loggedInUser = response;
      this.imageData = response.profile_pic;
      this.imageExists = true;
      localStorage.setItem('profileData', JSON.stringify(response));
      if (this.imageData === '' || this.imageData == null) {
        this.loggedInInitialsFlag = true;
        this.imageExists = false;
      } else {
        this.loggedInInitialsFlag = false;
      }
      EventBus.$emit('updateProfile', true);
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${
        lastname ? lastname.charAt(0).toUpperCase() : ''
      }`;
    }
  }
};
</script>
<style lang="scss" scoped>
$font-style-normal: normal;
.deactive-modal {
  .modal-dialog {
    position: fixed;
    right: -212px;
    bottom: -30px;
  }
}
.modal-content {
  &.deactivate-acct {
    width: 493px;
  }
}
.deactivate-acct {
  .expiry-img {
    padding: 6px 19px 0px 0px;
  }
  .modal-title {
    span {
      padding-top: 3px;
      color: $black;
      font-weight: $font-weight-medium;
      font-size: $font-24;
      line-height: 28px;
    }
  }
  .deactivate-body {
    font-weight: $font-weight-medium;
    font-size: $font-14;
    line-height: 16px;
    color: $dark-black-alpha;
    padding: 0px 19px 24px 71px;
  }
}
.modal-header {
  &.upgradeModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-top-left-radius: $radius10;
    border-top-right-radius: $radius10;
    padding: 13px 11px 0px 19px;
  }
  .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: $deep-gray !important;
    font-weight: $font-weight-small;
    font-size: $font-30;
  }
}
.modal-footer {
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding: 0px 15px 16px 0px;
  }
}
.proceed-btn {
  padding: 7px 0px;
  width: 136px;
}
.please-cancel,
.please-cancel:hover,
.please-cancel:active {
  font-weight: $font-weight-medium;
  font-size: $font-18;
  line-height: 21px;
  color: $primary;
  background: $deep-white;
  text-align: center;
}
.limit_popover_txt {
  text-align: left;
  word-break: normal;
}
.support-access {
  padding-top: 10px;
  padding-right: 35px;
  text-align: left;
}
.info-img {
  height: 18px;
  width: 18px;
}
.profile-footer-save {
  float: right;
}
.profile-confirm-poup {
  width: 500px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-style: $font-style-normal;
  @include fontItems($font-24, 28px, $font-weight-normal);
  text-align: center;
  color: $dark-black-alpha;
}
.confirmpopup-bgcolor {
  background-color: $deep-white;
  border: 0px;
  border-radius: $radius10;
}
#profile-icon {
  text-align: center;
}
.d-flex {
  display: flex;
}
.font-properties {
  font-style: $font-style-normal;
}
.emergo-drk-blue {
  color: $primary;
}
.fs-16 {
  font-size: 16px;
}
.ln-ht19 {
  line-height: 19px;
}
.font-weight-normal {
  font-weight: $font-weight-normal;
}
.font-weight-bold {
  font-weight: $font-weight-bold;
}
.font-weight-prop {
  font-weight: $font-weight-small;
}
.prd-dtls-pd {
  padding: 10px 0px 0px 0px;
}
.header-profile {
  padding: 15px 0px 0px 20px;
  font-style: normal;
  @include fontItems($font-28, 33px, $font-weight-small);
}
.remove_photo,
.remove_photo:focus {
  color: #2d9cdb;
  border: $radius0;
  background-color: $white;
  outline: none;
}
.remove_photo[disabled] {
  cursor: not-allowed;
}
.chng-photo {
  width: 170px;
  margin: 10px 0 10px 0;
}
.sec-pad {
  font-size: $font-16;
  line-height: 19px;
  color: $primary;
}
.sec-pad-line {
  padding: 10px 20px 0px 20px;
}
.icon-close {
  color: $deep-gray !important;
}
.form-control {
  margin-top: 6px;
}
.header-chng-pwd {
  padding: 10px 0px 0 20px;
  font-style: $font-style-normal;
  @include fontItems(19px, 33px, $font-weight-small);
}
.field_css {
  margin-bottom: 3%;
}
.profile-pic-edit {
  width: 170px;
  height: 170px;
  line-height: 170px;
  float: unset;
}
.profile-pic-title-edit {
  display: inline-block !important;
}
.footer {
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.file-upload-hide {
  margin: 0 auto;
  width: 170px;
}
#profile-body {
  max-height: calc(84vh - 142px);
  overflow-y: auto;
  overflow-x: hidden;
}
.required {
  color: $red;
}
.ps_lt_8_2 {
  left: 8.2em;
}
#divPasswordValidationResult {
  display: block;
  margin-top: 10px;
  padding: 5px;
  background: $deep-white;
  border: 1px solid $deep-thick-danger;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: $radius10;
}
.el-popover .content {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: $dark-black-alpha;
  text-align: left;
}

.el-popover .content ul li:not(:first-child) {
  padding-top: 10px;
}
.form-group {
  margin-bottom: 0px;
}
.password-flex {
  display: flex;
  input {
    padding: 6px 43px 6px 12px !important;
    &:focus-visible {
      padding-left: 11px !important;
    }
  }
}
.eye-icon,
.eye-slash-icon {
  margin-top: 15px;
}
.invalid-border {
  border-color: $light-danger;
  &:focus {
    border-color: $light-danger;
  }
}
.pb-22 {
  padding-bottom: 22px;
}
.pass-info {
  display: flex;
  margin-top: 5px;
  .info-img {
    position: absolute;
    right: 15px;
    top: 3px;
  }
}
.pass-desc {
  font-style: normal;
  color: $dark-black-alpha;
  @include fontItems($font-18, 21px, $font-weight-400);
  text-align: left;
}
.custom-error-class {
  padding-left: 15px;
}
.ml-6 {
  margin-left: 6px;
}
@media (min-width: 768px) {
  #profile-icon {
    float: right;
  }
}
@media screen and (max-width: 374px) {
  .profile-confirm-poup {
    width: 250px;
  }
  .field_css {
    &.xs-mr-bt-0 {
      margin-bottom: 0%;
    }
  }
  .profile-pic-edit {
    width: 55px;
    height: 55px;
    line-height: 55px;
    float: unset;
  }
  .chng-photo {
    width: 120px;
    font-size: $font-14;
  }
  hr {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .support-access {
    text-align: left;
  }
}
@media screen and (max-width: 550px) {
  #profile-body {
    max-height: calc(84vh - 107px);
  }
}
@media (min-width: 375px) and (max-width: 767px) {
  .profile-confirm-poup {
    width: 300px;
  }
  .confirm-body {
    padding: 5% 5%;
    margin-bottom: 10%;
    font-size: $font-18;
    line-height: 21px;
  }
  .profile-pic-edit {
    width: 85px;
    height: 85px;
    line-height: 85px;
    float: unset;
  }
  .chng-photo {
    width: 150px;
  }
}
@media screen and (max-width: 767px) {
  .profile-footer-save {
    float: unset;
    margin-bottom: 14px;
  }
  .footer {
    padding-bottom: 5%;
  }
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
}
@media screen and (max-width: 1023px) {
  .support-access {
    text-align: left;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  #profile-body {
    max-height: calc(84vh - 295px);
  }
  .changepassword_wrapper {
    max-height: 43vh !important;
    overflow-y: auto;
  }
}
@media (min-width: 860px) and (max-width: 991px) {
  .pass-info {
    .info-img {
      right: 75px;
    }
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  #profile-body {
    max-height: 52vh !important;
  }
  .changepassword_wrapper {
    max-height: 52vh !important;
    overflow-y: auto;
  }
}
</style>
